module.exports = __webpack_public_path__ + "static/media/cineonstudio_change.59bcf84c.svg";